//INTERNAL ROUTES
export const SEARCH = '/buscar-mascotas/'
export const SEE_RESULTS = '/resultados-mascotas/'
export const DOG_PROFILE = '/mascotas/'
export const DIRECTORY = '/directorio/'